import { getUserCognitoGroups } from './auth-groups.util';
import { isCommercialInsurerUser } from './get-group';

/** Bloqueia perfis comerciais da seguradora em fluxos de subscrição/técnicos. */
export async function isCurrentUserCommercialInsurer(): Promise<boolean> {
  const groups = await getUserCognitoGroups();
  return isCommercialInsurerUser(groups);
}

export async function requireInsurerUnderwritingAccess(): Promise<boolean> {
  return !(await isCurrentUserCommercialInsurer());
}
